import VCDataRoom from "./VCDataRoom";

export default VCDataRoom;
